import {
  maxLength10,
  maxLength6,
  maxLength4,
  required,
  noDigits,
  number,
  trimError,
  onlyLettersAndHyphen,
  noHyphenStartOrEnd,
  onlyDigits,
  onlyLettersAndNumberAndHyphen,
  maxLength80,
  maxLength50,
  onlyLetters,
  trimNoSpecStartOrEnd,
  onlyHouse,
} from '../utils/validation';
import DTO from './DTO';

class AddressDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'postal_code',
        type: String,
        validators: [number, maxLength6],
        labelKey: 'pd.postal_code',
      },
      {
        name: 'country',
        type: String,
        validators: [required, noDigits, trimError, onlyLettersAndHyphen, noHyphenStartOrEnd, maxLength80],
        labelKey: 'pd.country',
      },
      {
        name: 'region',
        type: String,
        validators: [required, noDigits, trimError, onlyLettersAndHyphen, noHyphenStartOrEnd, maxLength80],
        labelKey: 'pd.region',
      },
      {
        name: 'area',
        type: String,
        validators: [noDigits, trimError, onlyLettersAndNumberAndHyphen, noHyphenStartOrEnd, maxLength80],
        labelKey: 'pd.area',
      },
      {
        name: 'place',
        type: String,
        validators: [noDigits, trimError, noHyphenStartOrEnd, maxLength80],
        labelKey: 'pd.place',
      },
      {
        name: 'city',
        type: String,
        validators: [trimError, noHyphenStartOrEnd, maxLength80],
        labelKey: 'pd.city',
      },
      {
        name: 'street',
        type: String,
        validators: [noDigits, trimError, onlyLettersAndNumberAndHyphen, noHyphenStartOrEnd, maxLength80],
        labelKey: 'pd.street',
      },
      {
        name: 'house',
        type: String,
        validators: [maxLength10, onlyHouse],
        labelKey: 'pd.house',
      },
      {
        name: 'external',
        type: String,
        validators: [maxLength4, onlyDigits],
        labelKey: 'pd.external',
      },
      {
        name: 'building',
        type: String,
        validators: [maxLength10, trimNoSpecStartOrEnd, trimError],
        labelKey: 'pd.building',
      },
      {
        name: 'apartment',
        type: String,
        validators: [maxLength50],
        labelKey: 'pd.apartment',
      },
      {
        name: 'letter',
        type: String,
        validators: [maxLength4, onlyLetters],
        labelKey: 'pd.letter',
      },
      {
        name: 'division',
        type: String,
        validators: [maxLength50],
        labelKey: 'pd.division',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    const data = {
      postal_code: this.postal_code,
      country: this.country,
      region: this.region,
      area: this.area,
      city: this.city,
      place: this.place,
      street: this.street,
      house: this.house,
      building: this.building,
      external: this.external,
      division: this.division,
      apartment: this.apartment,
      letter: this.letter,
    };
    return data;
  }
}

export default AddressDTO;
